import * as React from 'react';
import { Route } from 'react-router-dom';

function AppliedRoute({ component, props, ...rest }: any) {
    const Component = component;
    return (<Route {...rest} render={(routeProps: {}) => (<Component { ...routeProps } {...props} />)} />);
}

export { AppliedRoute };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/AppliedRoute.tsx